__turbopack_context__.v({
  "className": "inter_a4f980cf-module__uRJUFG__className",
  "variable": "inter_a4f980cf-module__uRJUFG__variable",
});
